
const LenderList = () => {


  const self = {
    init () {
      
      jQuery(document).ready(function ($) {
          
            $(document).on('click', '.c-lender_list_item .c-lender_list_item__read-more', function(e){
              e.preventDefault();
              $([document.documentElement, document.body]).animate({
                  scrollTop: $(this).closest('.c-lender_list_item.l-lender_list_item').offset().top
              }, 0);
              $(this).closest('.c-lender_list_item.l-lender_list_item').toggleClass('open');
            });
      });
      


      jQuery(document).ready(function () {
    
        jQuery('.lanakuten-listings .filter input').change(function (e) {
            e.preventDefault();
            let c = jQuery(this).attr('name');
            let parent = jQuery(this).closest('.lanakuten-listings');
    
            jQuery(parent).find('input').prop("checked", false);
            jQuery(this).prop("checked", true);
    
            jQuery(parent).removeClass('none utan snabblan all');
            jQuery(parent).addClass(c);
    
        });
    
        var getQueryParam = function(name){
            var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
            return results ? (results[1] || null) : null;
        }
        
        function getElementIndex(element) {
            return [].indexOf.call(element.parentNode.children, element);
        }
        
        function openInNewTab(url) {
            var win = window.open(url, '_blank');
            win.focus();
        }
    
        jQuery('body').on('click', '.epi-follow-link', function (e) {
    
           // e.preventDefault();

            let date = new Date();
            date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
            document.cookie = "last_clicked_url" + "=" + window.location.href + "; expires=" + date.toGMTString() + "; path=/";
            let mtstv = jQuery(this).attr('pid');
            document.cookie = "last_clicked_mtst"+"="+mtstv+"; expires="+date.toGMTString()+"; path=/";
    
            let link = jQuery(this).attr('href');
            let pid = jQuery(this).attr('pid');
            let title = jQuery(this).attr('title');
            let pos = jQuery(this).attr('num');
            let cid;
            getQueryParam('gclid') ? cid = getQueryParam('gclid') : cid = '';
    
           // console.log(title + '-' + pid + '-' + cid + 'pos-' + pos);
    
            mtst.cmd.push(function () {
                mtst.track({
                "type":"loan",
                "lead_id": pid,
                "click_id": cid,
                    "loan":{
                        "name": title,
                        "placement": pos
                    }
                },
                {
                    success: function () {
    
                    },
                    error: function () {
    
                    },
                    complete: function () {
                        console.log('epi ++ for: '+ title +' cid:'+cid+' pid:'+pid);
                        //openInNewTab(link);
                    }
                }
                
                
                
                
                );
            });
    
        });
        
    });




     
    }
  }

  return self
}

export default LenderList
